import { useSelector } from 'react-redux';
import React from 'react';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import SortByOption from '@stone/components/listing/SortByOption';
import classNames from 'classnames';
const SortBy = (props) => {
    const { productSort } = useSelector((state) => state.search);
    const { isMobile } = useMediaQueries();
    return (React.createElement("div", { className: classNames({ container: !isMobile }, 'sort__list--wrapper') },
        React.createElement("ul", { id: "exp_elem_list", className: "sort__list" }, productSort === null || productSort === void 0 ? void 0 : productSort.options.map((option, i) => (React.createElement(SortByOption, { key: i, index: i, option: option }))))));
};
export default SortBy;
